ApiPromise = require 'network/api-promise'
MemberMultiSelectAutocompleteComponent = require 'views/member/member-multi-select-autocomplete-component'
React = require 'react'
t = require('views/internal/recup-with-helpers')('org_members')
track = require 'debug/track'
_ = require 'underscore'

module.exports = class InviteTeamMembersAutoComplete extends React.Component
  constructor: (props) ->
    @model = props.model
    @onSubmit = @onSubmit.bind(@)
    @onAutocompleteSearch = @onAutocompleteSearch.bind(@)
    @onSelectMemberOption = @onSelectMemberOption.bind(@)
    @onRemoveMemberOption = @onRemoveMemberOption.bind(@)
    @state = {
      selectedMemberOptions: []
    }

  onSubmit: (users) ->
    return @model.addMembers(users)
    .then (grouped) =>
      for category, entries of grouped
        track("Invite Team Members AutoComplete", "Members Page", "Bulk Add", category, users.length)

  onAutocompleteSearch: (query) ->
    if query.length > 2
      ApiPromise(
        url: '/1/search/members/'
        type: 'get'
        data:
          query: query
          idOrganization: @props.orgId
        dataType: 'json'
      )
    else
      return []

  onSelectMemberOption: (member) ->
    { selectedMemberOptions } = @state
    @setState({
      selectedMemberOptions: _.uniq(
        _.union(selectedMemberOptions, _.flatten [member]),
        false,
        (item) => if item.username then item.username else item.email
      )
    })

  onRemoveMemberOption: (idx) ->
    { selectedMemberOptions } = @state
    @setState({
      selectedMemberOptions: selectedMemberOptions.filter((_, i) => i != idx)
    })

  render: t.renderable ->
    { selectedMemberOptions } = @state

    autocompleteProps = {
      placeholder: @props.placeholder
      onSubmit: @onSubmit
      onAutocompleteSearch: @onAutocompleteSearch
      displayDetails: true
      displayUsername: true
      submitText: t.l 'invite-to-team'
      onRemoveMemberOption: @onRemoveMemberOption
      onSelectMemberOption: @onSelectMemberOption
      selectedOptions: selectedMemberOptions
    }

    t.div '.org-team-members-autocomplete-container', =>
      t.createElement MemberMultiSelectAutocompleteComponent, autocompleteProps



// WEBPACK FOOTER //
// ./app/scripts/views/organization/invite-team-members-autocomplete-component.coffee